import { Resources } from 'constants/resources';

import { hydraSchemaAnalyzer } from '@api-platform/admin';
import { queryClient } from 'providers/queryClient';
import { HttpError, useCreate } from 'react-admin';
import { BankOperation } from 'types/embedded/bankOperation';
import { formatInputToTimestamp } from 'utils/date';

type Result = {
  createRequestsBankOps: (data: BankOperation) => void;
};

export function useCreateRequestsBankOps(
  handleOpenRecordModal: (data: BankOperation) => void,
  setErrors: (e: any) => void,
): Result {
  const [create] = useCreate<BankOperation>(Resources.RequestBankOperations);
  const createSingle = (data: BankOperation) => {
    return create(
      Resources.RequestBankOperations,
      {
        data: {
          ...data,
          dateOfOperation:
            formatInputToTimestamp(data.dateOfOperation, { unit: 'seconds' }) || undefined,
          description: data.description || '',
          amountPenny: data.amountPenny.toString(),
        },
      },
      {
        onError: async (e: any) => {
          const violations = hydraSchemaAnalyzer().getSubmissionErrors(e as HttpError);
          setErrors(violations);
          if (e?.response) {
            const errorBody = await e.response.json();
            setErrors(errorBody.errors);
          }
        },
        onSuccess: async (data: BankOperation) => {
          await queryClient.invalidateQueries({ queryKey: [Resources.RequestBankOperations] });
          handleOpenRecordModal(data);
        },
      },
    );
  };

  return {
    createRequestsBankOps: createSingle,
  };
}
